import { render, staticRenderFns } from "./PostImage.vue?vue&type=template&id=0272182e&scoped=true&"
import script from "./PostImage.vue?vue&type=script&lang=js&"
export * from "./PostImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0272182e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.clcp.cliquedomains.com/web/app/themes/clc-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0272182e')) {
      api.createRecord('0272182e', component.options)
    } else {
      api.reload('0272182e', component.options)
    }
    module.hot.accept("./PostImage.vue?vue&type=template&id=0272182e&scoped=true&", function () {
      api.rerender('0272182e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/vue/Components/Blocks/PostImage.vue"
export default component.exports